export const newOutwardNo = (state = '', action) => {
  if (action.type === 'FETCH_NEW_OUTWARD_NUMBER') {
    return action.payload;
  }
  if (action.type === 'CLEAR_NEW_OUTWARD_NUMBER') {
    return '';
  }
  return state;
};

export const storeOutwards = (state = [], action) => {
  if (action.type === 'FETCH_STORE_OUTWARDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_STORE_OUTWARDS') {
    return [];
  }
  return state;
};

export const storeOutward = (state = {}, action) => {
  if (action.type === 'FETCH_STORE_OUTWARD') {
    return action.payload;
  }
  if (action.type === 'CLEAR_STORE_OUTWARD') {
    return {};
  }
  return state;
};

export const outwardReport = (state = { items: [], summary: [] }, action) => {
  if (action.type === 'FETCH_OUTWARD_REPORT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_OUTWARD_REPORT') {
    return { items: [], summary: [] };
  }
  return state;
};

export const customerIdsForOutwardReport = (state = [], action) => {
  if (action.type === 'FETCH_CUSTOMER_IDS_FOR_OUTWARD_REPORT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_CUSTOMER_IDS_FOR_OUTWARD_REPORT') {
    return [];
  }
  return state;
};

export const jobchartIdsForOutwardReport = (state = [], action) => {
  if (action.type === 'FETCH_JOBCHART_IDS_FOR_OUTWARD_REPORT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_JOBCHART_IDS_FOR_OUTWARD_REPORT') {
    return [];
  }
  return state;
};

export const processesForOutwardReport = (state = [], action) => {
  if (action.type === 'FETCH_PROCESSES_FOR_OUTWARD_REPORT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_PROCESSES_FOR_OUTWARD_REPORT') {
    return [];
  }
  return state;
};

export const vendorIdsForOutwardReport = (state = [], action) => {
  if (action.type === 'FETCH_VENDOR_IDS_FOR_OUTWARD_REPORT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VENDOR_IDS_FOR_OUTWARD_REPORT') {
    return [];
  }
  return state;
};

export const rpoIdsForOutwardReport = (state = [], action) => {
  if (action.type === 'FETCH_RPO_IDS_FOR_OUTWARD_REPORT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_IDS_FOR_OUTWARD_REPORT') {
    return [];
  }
  return state;
};
